import React from "react";
import { ControlLabel, DropdownButton, MenuItem } from "react-bootstrap";
import ReportsUnapprovedHours from "./reports-unapproved-hours.jsx";
import ReportsTimecardActivity from "./reports-timecard-activity.jsx";
import ReportsMissingHours from "./reports-missing-hours.jsx";
import ReportsTimecardDetail from "./reports-timecard-detail.jsx";
import ReportsTaskReport from "./reports-task-report.jsx";
import ReportsCovidAssessment from "./reports-covid-assessment.jsx";
import ReportsEmployeePtoBalance from "./reports-employee-pto-balance";
import ReportsWorkLocation from "./reports-work-location";


export default class ReportsContent extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let report = null;

        switch (this.props.title) {
            case "Unapproved Hours":
                report = <ReportsUnapprovedHours role={this.props.role} />;
                break;

            case "Timecard Activity":
                report = <ReportsTimecardActivity role={this.props.role}  />;
                break;

            case "Missing Hours":
                report = <ReportsMissingHours role={this.props.role}  />;
                break;

            case "Timecard Detail":
                report = <ReportsTimecardDetail role={this.props.role} />;
                break;

            case "Task Report":
                report = <ReportsTaskReport role={this.props.role} />;
                break;

            case "Worksite Attendance – COVID-19 Assessment":
                report = <ReportsCovidAssessment role={this.props.role} />;
                break;

            case "Employee PTO Balance Report":
                report = <ReportsEmployeePtoBalance role={this.props.role} />;
                break;

            case "Work Location":
                report = <ReportsWorkLocation role={this.props.role} />;
                break;
        }

        return (
            <div className="col-md-12 col-lg-12">
                {report}
            </div>
        );
    }
}